import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delivery-payment',
  templateUrl: './delivery-payment.component.html',
  styleUrls: ['./delivery-payment.component.scss'],
})
export class DeliveryPaymentComponent implements OnInit {

  ctrl; data;

  constructor() { }

  total: number;

  ngOnInit() {
    const l = this.data?.dropoffs.length;
    const f = (l>5)?0:(7-((l-1)*1.5));
    this.total = (l*4) + f;
  }

  processing: boolean = false;

  submit(e) {
    this.ctrl.dismiss(true);
  }

}
